import { Navigate, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useCheckTokenExpiration } from '../../utility/authGuard';
import { usePermission } from '../core/hooks/usePermission';
 

const PrivateRoute = ({ children, requiredModule, requiredAction }) => {
  const { isAuthenticated } = useSelector(state => state.authReducer);
  const location = useLocation();
  const { hasPermission } = usePermission();
  const checkTokenExpiration = useCheckTokenExpiration();
  useEffect(() => {
    const isValid = checkTokenExpiration();
    if (!isValid) {
      localStorage.setItem('redirectUrl', location.pathname);
    }
  }, [checkTokenExpiration, location]);

  if (!hasPermission(requiredModule, requiredAction)) {
    return <Navigate to="/Unauthorized" state={{ from: location }} replace />;
  }

  if (!isAuthenticated || !checkTokenExpiration()) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

export default PrivateRoute;